import '../styles.scss'
import React from 'react'

import { Timer, Selector } from "components/SmartChatView/Fields"

const ProcessSearchViewUI = ({ renderType, label, placeholder, processesOptions, value, onChangeInner, loadingProcessesOptions, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <>
        <Timer
          isRequired
          label={label.timer}
          value={value.timer}
          onChange={value => onChangeInner({ fieldType: 'timer', fieldData: value })}
          exclude={['minutes', 'hours', 'days']}
          error={error?.timer}
        />
        {value.timer?.time > 0 && (
          <>
            <Selector
              isRequired
              label={label.completeProcess}
              placeholder={placeholder.completeProcess}
              options={processesOptions || []}
              value={value.completeProcess}
              onChange={value => onChangeInner({ fieldType: 'completeProcess', fieldData: value })}
              loading={loadingProcessesOptions}
              error={error?.completeProcess}
            />
            <Selector
              isRequired
              label={label.partialProcess}
              placeholder={placeholder.partialProcess}
              options={processesOptions || []}
              value={value.partialProcess}
              onChange={value => onChangeInner({ fieldType: 'partialProcess', fieldData: value })}
              loading={loadingProcessesOptions}
              error={error?.partialProcess}
            />
          </>
        )}
      </>
    )}
    {renderType === 'preview' && (
      <div className='action-view__process-search-preview'>
        <Timer
          value={value.timer}
          onChange={value => onChangeInner({ fieldType: 'timer', fieldData: value })}
          exclude={['minutes', 'hours', 'days']}
          error={previewIntegrity.timer}
        />
        <Selector
          placeholder={placeholder.completeProcess}
          options={processesOptions || []}
          value={value.completeProcess}
          onChange={value => onChangeInner({ fieldType: 'completeProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={previewIntegrity.completeProcess}
        />
        <Selector
          placeholder={placeholder.partialProcess}
          options={processesOptions || []}
          value={value.partialProcess}
          onChange={value => onChangeInner({ fieldType: 'partialProcess', fieldData: value })}
          loading={loadingProcessesOptions}
          error={previewIntegrity.partialProcess}
        />
      </div>
    )}
  </div>
)

export default ProcessSearchViewUI
